import styled from "styled-components";
import { NavLink } from "react-router-dom";

 export const Link = styled(NavLink)`
color: #ffffff;
text-decoration: none
`;

export const Nav = styled.div`
display: flex;
gap: 30px;
`;